import { Box, css, styled } from '@mui/material';

import { ResultStructuresList } from '@/components/result/ResultStructuresList';
import { DateForm } from '@/components/routing/DateForm';
import { RouteActionButtons } from '@/components/routing/RouteInputControls';
import { RoutingForm } from '@/components/routing/RoutingForm';
import { useRoutes } from '@/hooks/useRoutes';
import { TriasHelper } from '@/modules/TriasHelper';

const Root = styled(Box)(
  ({ theme }) => css`
    width: ${theme.spacing(45.25)};
  `,
);

const SectionWrapper = styled(Box)(
  ({ theme }) => css`
    border-radius: ${theme.spacing(1)};
    background-color: ${theme.palette.grey[100]};
    padding: ${theme.spacing(2)};
    margin-top: ${theme.spacing(3)};
    gap: ${theme.spacing(3)};
    width: ${theme.spacing(45.25)};
  `,
);

export function RoutePanel() {
  const route = useRoutes();
  const resultStructures = TriasHelper.getIndividualRouteStructures(route.data);
  const hasResults = (resultStructures?.length ?? 0) > 0 || route.isFetching;

  return (
    <Root>
      <SectionWrapper>
        <RoutingForm />
        <RouteActionButtons />
      </SectionWrapper>

      <SectionWrapper>
        <DateForm />
      </SectionWrapper>

      {hasResults ? <SectionWrapper>
          <ResultStructuresList />
        </SectionWrapper> : null}
    </Root>
  );
}
